/**
 * Textos da página Sobre (layout editorial clássico, alinhado ao sosvor-artisan-web).
 * Chaves: aboutPageClassic.* - use t('aboutPageClassic.pageTitle'), etc.
 */

export const aboutPageClassicBundles = {
  pt: {
    pageTitle: 'Engenharia, tecnologia e impacto com propósito.',
    identityEyebrow: 'Identidade',
    peopleEyebrow: 'Pessoas',
    peopleTitle: 'Uma equipa multidisciplinar.',
    peopleTitlePrefix: 'Uma equipa ',
    peopleTitleHighlight: 'multidisciplinar.',
    peopleP1:
      'Contamos com uma equipa de engenheiros, especialistas de tecnologia, designers e formadores que trabalham lado a lado para entregar soluções coerentes, onde cada disciplina amplifica o valor da outra. Esta diversidade de competências permite-nos olhar para cada desafio com várias perspetivas e responder com rigor técnico, criatividade e sentido prático.',
    peopleP2:
      'Combinamos experiência local com referências internacionais para servir clientes corporativos, instituições públicas e particulares com o mesmo padrão de exigência. Valorizamos a escuta, o trabalho em equipa e a partilha de conhecimento, porque acreditamos que as melhores soluções nascem quando pessoas diferentes colaboram com foco no mesmo objectivo.',
    missionKicker: 'I · Missão',
    missionH2:
      'Temos como missão ajudar na integração de soluções inovadoras com impacto real.',
    missionH2a: 'Temos como ',
    missionH2Highlight1: 'missão',
    missionH2b: ' ajudar na ',
    missionH2Highlight2: 'integração de soluções',
    missionH2c: ' inovadoras com impacto real.',
    visionKicker: 'II · Visão',
    visionH2:
      'A nossa visão consiste em tornar-nos uma referência em soluções integradas e sustentáveis.',
    visionH2a: 'A nossa ',
    visionH2Highlight1: 'visão consiste',
    visionH2b: ' em tornar-nos uma ',
    visionH2Highlight2: 'referência em soluções',
    visionH2c: ' integradas e sustentáveis.',
    principlesEyebrow: 'Princípios',
    principlesH2: 'Os nossos valores',
    principlesIntro: 'Os fundamentos que orientam cada decisão e cada entrega.',
    storyEyebrow: 'História',
    storyH2: 'Da ideia ao impacto.',
    storyH2Prefix: 'Da ideia ao ',
    storyH2Highlight: 'impacto',
    storyH2Rest: '.',
    storyP1a: 'A ',
    storyP1b:
      ' nasceu da convicção de que Angola precisa de empresas técnicas capazes de entregar soluções integradas, onde engenharia, tecnologia, segurança, design e formação não são silos, mas peças coordenadas de um único sistema de valor.',
    storyP2a: 'Como marca da ',
    storyP2b:
      ', herdamos uma cultura de exigência, ética e proximidade ao cliente. Cada projeto é tratado como uma relação de longo prazo: com escuta, transparência, prazos cumpridos e responsabilidade pelos resultados.',
    numbersEyebrow: 'A SOSVOR em números',
    num1: '06',
    num1L: 'Áreas integradas',
    num2: '24/7',
    num2L: 'Suporte técnico',
    num3: '100+',
    num3L: 'Projetos entregues',
    num4: '5+',
    num4L: 'Anos de experiência',
    approachEyebrow: 'Abordagem',
    approachH2: 'Como trabalhamos.',
    approachH2Prefix: 'Como traba',
    approachH2Highlight: 'lhamos',
    approachH2Rest: '.',
    approachIntro: 'Um método claro, replicável e centrado na entrega de valor real.',
    ap1t: 'Escuta activa',
    ap1d: 'Compreendemos o contexto, os objectivos e as restrições antes de propor qualquer solução.',
    ap2t: 'Desenho integrado',
    ap2d: 'Combinamos competências de várias áreas para desenhar a solução mais coerente.',
    ap3t: 'Execução disciplinada',
    ap3d: 'Plano, prazos, qualidade e custos sob controlo do início ao fim.',
    ap4t: 'Acompanhamento contínuo',
    ap4d: 'Suporte pós-entrega, manutenção e evolução das soluções implementadas.',
    commitmentsEyebrow: 'Compromissos',
    comH2: 'O que pode esperar de nós.',
    comH2Highlight: 'O que',
    comH2Rest: ' pode esperar de nós.',
    comIntro:
      'Os nossos compromissos não são slogans, são critérios pelos quais aceitamos ser avaliados em cada projeto.',
    c1: 'Transparência total em prazos, custos e dependências.',
    c2: 'Responsabilidade técnica do início ao fim do projeto.',
    c3: 'Soluções desenhadas à medida; nunca um modelo único.',
    c4: 'Ética profissional e respeito pelo cliente e pelos colaboradores.',
    c5: 'Sustentabilidade integrada nas decisões técnicas.',
    brandEyebrow: 'Significado da marca',
    brandH2: 'SOSVOR, letra a letra',
    brandIntro: 'Cada letra da sigla representa os valores e princípios que sustentam a nossa identidade:',
    acronym1t: 'S · Soluções',
    acronym1d:
      'Compromisso com a entrega de soluções integradas, criativas e eficazes para cada desafio apresentado.',
    acronym2t: 'O · Organizadas',
    acronym2d: 'Atuação baseada em planeamento, eficiência e métodos bem estruturados.',
    acronym3t: 'S · Sustentáveis',
    acronym3d: 'Promoção de práticas sustentáveis, com respeito pelo meio ambiente e pelo futuro.',
    acronym4t: 'V · Valiosas',
    acronym4d: 'Geração de valor real para os clientes e para a sociedade com serviços de alta qualidade.',
    acronym5t: 'O · Operacionais',
    acronym5d: 'Capacidade comprovada de executar projectos com resultados concretos.',
    acronym6t: 'R · Responsáveis',
    acronym6d: 'Atuação ética e transparente, com compromisso social e profissionalismo.',
    diffEyebrow: 'Diferenciação',
    diffH2: 'Por que escolher a SOSVOR?',
    diffIntro: 'Na SOSVOR, destacamos os nossos diferenciais competitivos:',
    why1t: 'Abordagem multidisciplinar',
    why1d:
      'Integramos engenharia, tecnologia, design e turismo para oferecer soluções completas e personalizadas, conectando diferentes áreas do conhecimento para resultados superiores.',
    why2t: 'Compromisso com a sustentabilidade',
    why2d:
      'Aplicamos boas práticas ambientais em todas as etapas dos projetos, garantindo equilíbrio entre desenvolvimento e preservação do meio ambiente.',
    why3t: 'Equipa especializada',
    why3d:
      'Profissionais altamente qualificados, com experiência comprovada em projetos nacionais e internacionais, garantindo excelência em cada entrega.',
    why4t: 'Inovação constante',
    why4d:
      'Tecnologias de ponta e métodos inovadores para soluções eficientes, seguras e de alta performance, focadas nas suas necessidades.',
    parentEyebrow: 'Empresa-mãe',
    parentBrandOf: 'marca da',
    imgSosvorAlt: 'Logotipo SOSVOR',
    parentH2: 'BONGO SOLUÇÕES-SERVIÇOS (SU) LDA',
    parentBodyA: 'A ',
    parentBodyB: ' é uma marca da ',
    parentBodyC:
      ', um grupo focado em criar valor através de serviços técnicos integrados, com presença em Angola e ambição internacional.',
    parentCta: 'Contactar',
    imgTeamAlt: 'Pessoas de equipas diversas com as mãos unidas, trabalho em conjunto',
    imgStoryAlt: 'Técnica a monitorizar sistemas num data center',
    imgParentAlt: 'Logotipo BONGO SOLUÇÕES-SERVIÇOS (SU) LDA',
  },
  en: {
    pageTitle: 'Engineering, technology and purposeful impact.',
    identityEyebrow: 'Identity',
    peopleEyebrow: 'People',
    peopleTitle: 'A multidisciplinary team.',
    peopleTitlePrefix: 'A ',
    peopleTitleHighlight: 'multidisciplinary team.',
    peopleP1:
      'We have a team of engineers, technology specialists, designers and trainers who work side by side to deliver coherent solutions, where each discipline amplifies the value of the others. This breadth of skills lets us approach every challenge from multiple angles and respond with technical rigour, creativity and practical sense.',
    peopleP2:
      'We combine local experience with international references to serve corporate clients, public institutions and individuals with the same standard of excellence. We value listening, teamwork and knowledge sharing, because we believe the best solutions emerge when different people collaborate towards the same goal.',
    missionKicker: 'I · Mission',
    missionH2:
      'Our mission is to help integrate innovative solutions with real impact.',
    missionH2a: 'Our ',
    missionH2Highlight1: 'mission',
    missionH2b: ' is to help ',
    missionH2Highlight2: 'integrate innovative solutions',
    missionH2c: ' with real impact.',
    visionKicker: 'II · Vision',
    visionH2:
      'Our vision is to become a benchmark for integrated, sustainable solutions.',
    visionH2a: 'Our ',
    visionH2Highlight1: 'vision is',
    visionH2b: ' to become a ',
    visionH2Highlight2: 'benchmark for integrated',
    visionH2c: ', sustainable solutions.',
    principlesEyebrow: 'Principles',
    principlesH2: 'Our values',
    principlesIntro: 'The foundations that guide every decision and delivery.',
    storyEyebrow: 'Our story',
    storyH2: 'From idea to impact.',
    storyH2Prefix: 'From idea to ',
    storyH2Highlight: 'impact',
    storyH2Rest: '.',
    storyP1a: '',
    storyP1b:
      ' was born from the belief that Angola needs technical companies capable of delivering integrated solutions, where engineering, technology, security, design and training are not silos, but coordinated parts of a single value system.',
    storyP2a: 'As a brand of ',
    storyP2b:
      ', we inherit a culture of high standards, ethics and proximity to clients. Every project is treated as a long-term relationship: with listening, transparency, on-time delivery and ownership of outcomes.',
    numbersEyebrow: 'SOSVOR in numbers',
    num1: '06',
    num1L: 'Integrated practices',
    num2: '24/7',
    num2L: 'Technical support',
    num3: '100+',
    num3L: 'Projects delivered',
    num4: '5+',
    num4L: 'Years of experience',
    approachEyebrow: 'Approach',
    approachH2: 'How we work.',
    approachH2Prefix: 'How we ',
    approachH2Highlight: 'work',
    approachH2Rest: '.',
    approachIntro: 'A clear, repeatable method centred on delivering real value.',
    ap1t: 'Active listening',
    ap1d: 'We understand context, goals and constraints before proposing any solution.',
    ap2t: 'Integrated design',
    ap2d: 'We combine skills from multiple areas to design the most coherent solution.',
    ap3t: 'Disciplined execution',
    ap3d: 'Plan, timeline, quality and budget under control from start to finish.',
    ap4t: 'Continuous follow-up',
    ap4d: 'Post-delivery support, maintenance and evolution of the solutions deployed.',
    commitmentsEyebrow: 'Commitments',
    comH2: 'What you can expect from us.',
    comH2Highlight: 'What',
    comH2Rest: ' you can expect from us.',
    comIntro:
      'Our commitments are not slogans, they are the criteria by which we accept to be measured on every project.',
    c1: 'Full transparency on timelines, costs and dependencies.',
    c2: 'Technical accountability from start to finish.',
    c3: 'Tailor-made solutions; never a one-size-fits-all template.',
    c4: 'Professional ethics and respect for clients and team.',
    c5: 'Sustainability built into technical decisions.',
    brandEyebrow: 'Brand meaning',
    brandH2: 'SOSVOR, letter by letter',
    brandIntro: 'Each letter in the acronym reflects the values and principles behind our identity:',
    acronym1t: 'S · Solutions',
    acronym1d: 'Delivering integrated, creative and effective solutions for every challenge.',
    acronym2t: 'O · Organised',
    acronym2d: 'Work grounded in planning, efficiency and sound methods.',
    acronym3t: 'S · Sustainable',
    acronym3d: 'Promoting sustainable practices with respect for the environment and the future.',
    acronym4t: 'V · Valuable',
    acronym4d: 'Creating real value for clients and society through high-quality services.',
    acronym5t: 'O · Operational',
    acronym5d: 'Proven ability to execute projects with concrete results.',
    acronym6t: 'R · Responsible',
    acronym6d: 'Ethical, transparent conduct with social and professional commitment.',
    diffEyebrow: 'Differentiation',
    diffH2: 'Why choose SOSVOR?',
    diffIntro: 'We highlight our competitive differentiators:',
    why1t: 'Multidisciplinary approach',
    why1d:
      'We combine engineering, technology, design and tourism for complete, tailored solutions, connecting disciplines for superior outcomes.',
    why2t: 'Commitment to sustainability',
    why2d:
      'Environmental good practice at every project stage, balancing development with preservation.',
    why3t: 'Specialised team',
    why3d:
      'Highly qualified professionals with proven experience on national and international projects.',
    why4t: 'Constant innovation',
    why4d:
      'State-of-the-art technologies and innovative methods for efficient, secure, high-performance solutions focused on your needs.',
    parentEyebrow: 'Parent company',
    parentBrandOf: 'brand of',
    imgSosvorAlt: 'SOSVOR logo',
    parentH2: 'BONGO SOLUÇÕES-SERVIÇOS (SU) LDA',
    parentBodyA: '',
    parentBodyB: ' is a brand of ',
    parentBodyC:
      ', a group focused on creating value through integrated technical services, based in Angola with international ambition.',
    parentCta: 'Contact us',
    imgTeamAlt: 'Diverse team members joining hands, collaboration and unity',
    imgStoryAlt: 'Technician monitoring systems in a data center',
    imgParentAlt: 'BONGO SOLUÇÕES-SERVIÇOS (SU) LDA logo',
  },
  fr: {
    pageTitle: 'Ingénierie, technologie et impact avec un sens clair.',
    identityEyebrow: 'Identité',
    peopleEyebrow: 'Personnes',
    peopleTitle: 'Une équipe pluridisciplinaire.',
    peopleTitlePrefix: 'Une équipe ',
    peopleTitleHighlight: 'pluridisciplinaire.',
    peopleP1:
      'Nous comptons sur une équipe d’ingénieurs, de spécialistes technologiques, de designers et de formateurs qui travaillent ensemble pour livrer des solutions cohérentes, où chaque discipline renforce la valeur des autres. Cette diversité de compétences nous permet d’aborder chaque défi sous plusieurs angles et d’y répondre avec rigueur technique, créativité et sens pratique.',
    peopleP2:
      'Nous combinons l’expérience locale avec des références internationales pour servir les entreprises, les institutions et les particuliers avec le même niveau d’exigence. Nous valorisons l’écoute, le travail d’équipe et le partage de connaissances, car nous croyons que les meilleures solutions naissent lorsque des personnes différentes collaborent vers un même objectif.',
    missionKicker: 'I · Mission',
    missionH2:
      'Notre mission est d’aider à intégrer des solutions innovantes à impact réel.',
    missionH2a: 'Notre ',
    missionH2Highlight1: 'mission',
    missionH2b: ' est d’aider à ',
    missionH2Highlight2: 'intégrer des solutions',
    missionH2c: ' innovantes à impact réel.',
    visionKicker: 'II · Vision',
    visionH2:
      'Notre vision est de devenir une référence en solutions intégrées et durables.',
    visionH2a: 'Notre ',
    visionH2Highlight1: 'vision est',
    visionH2b: ' de devenir une ',
    visionH2Highlight2: 'référence en solutions',
    visionH2c: ' intégrées et durables.',
    principlesEyebrow: 'Principes',
    principlesH2: 'Nos valeurs',
    principlesIntro: 'Les fondements qui guident chaque décision et chaque livraison.',
    storyEyebrow: 'Histoire',
    storyH2: 'De l’idée à l’impact.',
    storyH2Prefix: 'De l’idée à l’',
    storyH2Highlight: 'impact',
    storyH2Rest: '.',
    storyP1a: '',
    storyP1b:
      ' est née de la conviction que l’Angola a besoin d’entreprises techniques capables de livrer des solutions intégrées, où ingénierie, technologie, sécurité, design et formation ne sont pas des silos, mais des pièces coordonnées d’un même système de valeur.',
    storyP2a: 'En tant que marque de ',
    storyP2b:
      ', nous héritons d’une culture d’exigence, d’éthique et de proximité client. Chaque projet est une relation long terme : écoute, transparence, respect des délais et responsabilité des résultats.',
    numbersEyebrow: 'SOSVOR en chiffres',
    num1: '06',
    num1L: 'Domaines intégrés',
    num2: '24/7',
    num2L: 'Support technique',
    num3: '100+',
    num3L: 'Projets livrés',
    num4: '5+',
    num4L: "Années d'expérience",
    approachEyebrow: 'Approche',
    approachH2: 'Notre façon de travailler.',
    approachH2Prefix: 'Notre façon de travaill',
    approachH2Highlight: 'er',
    approachH2Rest: '.',
    approachIntro: 'Une méthode claire, reproductible et centrée sur la valeur.',
    ap1t: 'Écoute active',
    ap1d: 'Nous comprenons le contexte, les objectifs et les contraintes avant toute proposition.',
    ap2t: 'Conception intégrée',
    ap2d: 'Nous combinons plusieurs métiers pour concevoir la solution la plus cohérente.',
    ap3t: 'Exécution disciplinée',
    ap3d: 'Planning, délais, qualité et coûts maîtrisés du début à la fin.',
    ap4t: 'Suivi continu',
    ap4d: 'Support après livraison, maintenance et évolution des solutions déployées.',
    commitmentsEyebrow: 'Engagements',
    comH2: 'Ce que vous pouvez attendre de nous.',
    comH2Highlight: 'Ce que',
    comH2Rest: ' vous pouvez attendre de nous.',
    comIntro:
      'Nos engagements ne sont pas des slogans : ce sont les critères sur lesquels nous acceptons d’être jugés sur chaque projet.',
    c1: 'Transparence totale sur délais, coûts et dépendances.',
    c2: 'Responsabilité technique de bout en bout.',
    c3: 'Solutions sur mesure; jamais de modèle unique imposé.',
    c4: 'Éthique professionnelle et respect des clients et des équipes.',
    c5: 'Durabilité intégrée aux choix techniques.',
    brandEyebrow: 'Sens de la marque',
    brandH2: 'SOSVOR, lettre par lettre',
    brandIntro: 'Chaque lettre du sigle reflète les valeurs et principes qui fondent notre identité :',
    acronym1t: 'S · Solutions',
    acronym1d: 'Engagement pour des solutions intégrées, créatives et efficaces à chaque défi.',
    acronym2t: 'O · Organisées',
    acronym2d: 'Action fondée sur la planification, l’efficacité et des méthodes structurées.',
    acronym3t: 'S · Durables',
    acronym3d: 'Pratiques durables et respect de l’environnement et de l’avenir.',
    acronym4t: 'V · Valorisantes',
    acronym4d: 'Création de valeur réelle pour les clients et la société, avec des services de haute qualité.',
    acronym5t: 'O · Opérationnelles',
    acronym5d: 'Capacité avérée d’exécuter des projets avec des résultats concrets.',
    acronym6t: 'R · Responsables',
    acronym6d: 'Conduite éthique et transparente, engagement social et professionnalisme.',
    diffEyebrow: 'Différenciation',
    diffH2: 'Pourquoi choisir SOSVOR ?',
    diffIntro: 'Nous mettons en avant nos atouts concurrentiels :',
    why1t: 'Approche multidisciplinaire',
    why1d:
      'Nous intégrons ingénierie, technologie, design et tourisme pour des solutions complètes et sur mesure.',
    why2t: 'Engagement pour la durabilité',
    why2d:
      'Bonnes pratiques environnementales à chaque étape, équilibre entre développement et préservation.',
    why3t: 'Équipe spécialisée',
    why3d:
      'Professionnels hautement qualifiés, expérience nationale et internationale, excellence à chaque livraison.',
    why4t: 'Innovation constante',
    why4d:
      'Technologies de pointe et méthodes innovantes pour des solutions performantes, sûres et adaptées à vos besoins.',
    parentEyebrow: 'Société mère',
    parentBrandOf: 'marque de',
    imgSosvorAlt: 'Logo SOSVOR',
    parentH2: 'BONGO SOLUÇÕES-SERVIÇOS (SU) LDA',
    parentBodyA: '',
    parentBodyB: ' est une marque de ',
    parentBodyC:
      ', un groupe axé sur la création de valeur par des services techniques intégrés, présent en Angola avec une ambition internationale.',
    parentCta: 'Nous contacter',
    imgTeamAlt: 'Personnes de profils variés joignant les mains, collaboration',
    imgStoryAlt: 'Technicienne surveillant les systèmes dans un centre de données',
    imgParentAlt: 'Logo BONGO SOLUÇÕES-SERVIÇOS (SU) LDA',
  },
}
